<template>
	<div class="final-commitment-summary">
		<b-row class="title d-flex justify-content-between mx-0 mb-3">
			<b-col cols="12" md="4">
				<h3 class="font-weight-500">Final Commitment Summary</h3>
			</b-col>
			<b-col cols="12" md="4">
				<div class="d-flex align-items-center float-right">
					<p>Total:</p>
					<h2 :class="'mx-2 '+_gHlp.getNumberColorClass(proposal.final_commitment_summary.total_final)">RM {{ proposal.final_commitment_summary.total_final | moneyFormatter }}</h2>
					<p class="text-primary cursor-pointer" @click="modals.show_commitment_summary = true">view details</p>
				</div>
			</b-col>
		</b-row>
		<b-row>
			<b-col cols="12" md="4">
				<b-card no-body class="p-3">
					<p class="text-muted">Cust Detail Net Income /  Financial Prop Net Income</p>
					<h2><span :class="_gHlp.getNumberColorClass(_gHlp.getValue(proposal,'final_commitment_summary.detail_inflow.net_income.amount_before',0))">RM {{ _gHlp.getValue(proposal,'final_commitment_summary.detail_inflow.net_income.amount_before',0) | moneyFormatter }}</span> / <span :class="_gHlp.getNumberColorClass(_gHlp.getValue(proposal,'final_commitment_summary.detail_inflow.net_income.amount_after',0))">RM {{ _gHlp.getValue(proposal,'final_commitment_summary.detail_inflow.net_income.amount_after',0) | moneyFormatter }}</span></h2>
					<!-- <p class="text-success text-xs">
							<svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="10" height="22" viewBox="0 0 320 512"><path fill="currentColor" d="M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9S19 320.1 32 320.1h256c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"/></svg>
							Improved RM {{ 1000 | moneyFormatter }}
					</p> -->
					<p class="text-primary cursor-pointer" @click="modals.show_total_inflow = true">view details ></p>
				</b-card>
			</b-col>
			<b-col cols="12" md="4">
				<b-card no-body class="p-3">
					<p class="text-muted">Total Variable Expenses</p>
					<h2>RM {{ proposal.final_commitment_summary.total_variable_expenses | moneyFormatter }}</h2>
					<!-- <p class="font-weight-900 text-muted">-</p> -->
					<p class="text-primary cursor-pointer" @click="modals.show_total_variable_expenses = true">view details ></p>
				</b-card>
			</b-col>
			<b-col cols="12" md="4">
				<b-card no-body class="p-3">
					<p class="text-muted">Total Commitment</p>
					<h2>RM {{ proposal.final_commitment_summary.total_commitment | moneyFormatter }}</h2>
					<p class="text-primary cursor-pointer" @click="$refs.detail_com_sum_drawer.viewDetailOutflow()">view details ></p>
				</b-card>
			</b-col>
		</b-row>

		<TotalInflowModal :show_total_inflow.sync="modals.show_total_inflow" :detailInflow="proposal.final_commitment_summary.detail_inflow" />
		<DetailVarExpensesModal :show_total_variable_expenses.sync="modals.show_total_variable_expenses" :detailVarExpenses="proposal.final_commitment_summary.detail_variable_expenses" />
		<CommitmentSummaryModal :show_commitment_summary.sync="modals.show_commitment_summary" :detailInflow="proposal.final_commitment_summary.detail_inflow" :allCommitment="allCommitment" :detailVarExpenses="proposal.final_commitment_summary.detail_variable_expenses"/>
		<DrawerCommitmentSummary ref="detail_com_sum_drawer" :allCommitment="allCommitment" />
	</div>
</template>
<script>
import TotalInflowModal from '@/views/InitialProposal/Modals/TotalInflowModal'
import DetailVarExpensesModal from '@/views/InitialProposal/Modals/DetailVarExpensesModal'
import CommitmentSummaryModal from '@/views/InitialProposal/Modals/CommitmentSummaryModal'
import DrawerCommitmentSummary from '@/views/InitialProposal/Drawers/DrawerCommitmentSummary'

export default {
	props: ['proposal', 'current_customer'],
	components: {
		DrawerCommitmentSummary,
		TotalInflowModal,
		CommitmentSummaryModal,
		DetailVarExpensesModal
	},
	data() {
		return {
			modals: {
				show_total_inflow: false,
				show_commitment_summary: false,
				show_total_commitment: false,
				show_total_variable_expenses: false
			},
			financial_proposal: null,
			net_income: 0,
			allCommitment: []
		}
	},
	watch: {
		proposal: {
			handler(newVal) {
				this.allCommitment = [];
				if (!_gHlp.isEmpty(newVal.ccris_items)) {
					newVal.ccris_items.forEach(item => {
						this.allCommitment.push(item)
					});
				}
				if (!_gHlp.isEmpty(newVal.additional_commitments)) {
					newVal.additional_commitments.forEach(item => {
						this.allCommitment.push(item)
					});
				}
				if (!_gHlp.isEmpty(newVal.product_applications)) {
					newVal.product_applications.forEach(item => {
						this.allCommitment.push(item)
					});
				}
			},
			immediate: true,
		}
	},
	computed: {
		total_net_income() {
			if(_gHlp.isEmpty(this.current_customer) || _gHlp.isEmpty(this.current_customer.incomes) || _gHlp.isEmpty(this.current_customer.incomes.main) || _gHlp.isEmpty(this.current_customer.incomes.main.net_income)) return 0;
			return this.current_customer.incomes.main.net_income
		},
		total_var_expenses() {
			if(_gHlp.isEmpty(this.proposal) || _gHlp.isEmpty(this.proposal.final_commitment_summary) || _gHlp.isEmpty(this.proposal.final_commitment_summary.total_variable_expenses)) return 0;
			return this.proposal.final_commitment_summary.total_variable_expenses
		},
		total_comitment() {
			if(_gHlp.isEmpty(this.allCommitment)) return 0;
			return _.sumBy(this.allCommitment, function(o) { return (o.pcom_is_include == 1) ? parseFloat(o.pcom_final_installment) : 0; });
		},
		total_final() {
			if(_gHlp.isEmpty(this.allCommitment)) return 0;
			return parseFloat(this.total_net_income) - ( parseFloat(this.total_var_expenses) + parseFloat(this.total_comitment));
		},
	},
	created() {
	},
	methods: {
	}
}
</script>
